/**
 * Returns a random number
 * @param {number} min
 * @param {number} max
 * @returns {number} number
 */
// eslint-disable-next-line import/prefer-default-export
export function rand(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

/**
 * Returns a formatted currency string.
 * @param {number} amount
 * @returns {string} currency
 */
export function formatMoney(amount) {
  const formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
  return formatter.format(amount);
}
